const $ = require("jquery");

const ChangeTabs = {

  init() {
    const $items = $('.js-change-tab');
    var $$ = this;
    if ( $items.length > 0 ) {
      $('.c-tab--wrap.js-change-tab .c-tab').on('mouseover',function(e){
        e.preventDefault();
        $$.setup($(this));
      });
    }

    const $clickableTabs = $('.js-change-clicked-tab');
    if ( $clickableTabs.length > 0 ) {
      $('.c-tab--wrap.js-change-clicked-tab .c-tab').on('click',function(e){
        e.preventDefault();
        if($(this).hasClass('c-tab--all')){
          $$.showAll($(this));
        }else{
          $$.setup($(this));
        }
        
      });
    }
  },
  setup(el) {
    // Instanced version of above
      var num_id = el.attr('class').match(/c-tab--(\d+)/)[1];
      el.parents('.c-tab--wrap').find('.c-tab, .c-tab--content').removeClass('c-tab--active').removeAttr('href');
      el.addClass('c-tab--active');
      el.closest('.c-tab--wrap').find('.content-'+num_id).addClass('c-tab--active');
      el.parents('.c-tab--wrap').attr('data-active', num_id);
    
      $(function () {
        var hash = $.trim( window.location.hash );

        if (hash) {
            $('.c-tab[href$="'+hash+'"]').trigger('click');
        }
      });
  },
  showAll(el) {
    el.parents('.c-tab--wrap').find('.c-tab, .c-tab--content').removeClass('c-tab--active').removeAttr('href');
    el.addClass('c-tab--active');
    
    if($('.content-all .l-grid').html().trim() == ''){
      $('.c-tab--content').each( (_, content) => {
        const $$ = $(content);
        if(!$$.hasClass('content-all') && 
        !$$.hasClass ('c-tab--exclude-from-all')){
          var content = $$.find('.l-grid').html();
          el.closest('.c-tab--wrap').find('.content-all .l-grid').append(content);


          $('.c-card-contact').click(function(){
            if($(this).hasClass('close')){
                closeDetails($(this));
            }else{
                showDetails($(this));
            }
          });
        }
      });
    }
    
    el.closest('.c-tab--wrap').find('.content-all').addClass('c-tab--active');
    el.parents('.c-tab--wrap').attr('data-active', 'all');
    
   
    $(function () {
      var hash = $.trim( window.location.hash );

      if (hash) {
          $('.c-tab[href$="'+hash+'"]').trigger('click');
      }
    });
  },
};
$(ChangeTabs.init.bind(ChangeTabs));